/* eslint-disable no-dupe-keys */
export default {
  discount_settlement_rule: {
    name: '优惠结算规则',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '规则名称',
      merchant_discount_rate: '商家让利比例',
      sharing_fee_rate: 'ECMP渠道费率',
      charge_channel: '充电渠道',
      third_party_sharing_fee_rate: '第三方渠道费率',
      transaction_fee_rate: '手续费率',
      discountable_type: '优惠类型',
      discountable_ids: '优惠项目',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间',
      last_settled_at: '最近结算时间'
    },
    // Enum的属性
    statuses: {
      enabled: '生效中',
      disabled: '已失效'
    },
    // 占位提示
    placeholder: {
      search_keyword: '查询优惠结算规则名称',
      input_name: '请输入优惠结算规则名'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      ev_charging_station_settlements: '电站结算记录',
      discount_settlement: '订单优惠明细'
    },
    // 标签标题
    // 标题
    titles: {
      base_info: '基本信息',
      settled_billing_rule: '结算费率',
      discountable: '优惠项目'
    },
    group_titles: {
      base_info: '基本信息'
    },
    list_tabs: {
      all: '全部',
      enabled: '生效中',
      disabled: '已失效'
    },
    tips: {
      discount_settlement: '定时每月3号统一结算',
      sharing_fee_rate: '我方渠道推广费用',
      third_party_sharing_fee_rate: '第三方渠道推广费用，如美团、抖音。',
      merchant_discount_rate:
        '基于优惠券金额计算，商家让利部分不需要结算给商家。渠道费、手续费都是基于优惠券中非商家让利金额（商家实际结算金额）进行结算。'
    }
  }
}
